"use client";

import {
  PopoverContent,
  popoverVars,
} from "@faire/slate/private/popover/PopoverContent";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps extends React.ComponentProps<typeof PopoverContent> {
  zIndex?: number;
}

export const TooltipContent: React.FC<IProps> = ({
  zIndex,
  style,
  className,
  ...props
}) => {
  const tooltipVars = popoverVars({ zIndex });
  const tooltipCls = cn("fs-tooltip", className);

  return (
    <PopoverContent
      style={{ ...tooltipVars, ...style }}
      {...props}
      className={tooltipCls}
    />
  );
};
